import React from 'react';

import Icon from './Icon';

const AndroidDownloadIcon = (props) => {
    return (
        <Icon width='218' height='63' viewBox='0 0 218 63' {...props}>
            <defs>
                <linearGradient id='prefix__d' x1='50%' x2='50%' y1='0%' y2='100%'>
                    <stop offset='0%' stopColor='#257CB0' />
                    <stop offset='28.6%' stopColor='#4A93B5' />
                    <stop offset='76.7%' stopColor='#78BCBB' />
                    <stop offset='100%' stopColor='#89CFBD' />
                </linearGradient>
                <linearGradient id='prefix__g' x1='.001%' x2='100.001%' y1='49.999%' y2='49.999%'>
                    <stop offset='0%' stopColor='#52C1AD' />
                    <stop offset='100%' stopColor='#DEE89A' />
                </linearGradient>
                <linearGradient id='prefix__j' x1='50%' x2='50%' y1='0%' y2='100%'>
                    <stop offset='0%' stopColor='#EC413D' />
                    <stop offset='16.7%' stopColor='#DA4452' />
                    <stop offset='57.5%' stopColor='#B0487A' />
                    <stop offset='86.2%' stopColor='#954A92' />
                    <stop offset='100%' stopColor='#8A4A9D' />
                </linearGradient>
                <linearGradient id='prefix__m' x1='50.001%' x2='50.001%' y1='.001%' y2='99.997%'>
                    <stop offset='0%' stopColor='#F58879' />
                    <stop offset='11.9%' stopColor='#F69079' />
                    <stop offset='71.3%' stopColor='#FCB877' />
                    <stop offset='100%' stopColor='#FEC874' />
                </linearGradient>
                <path
                    id='prefix__c'
                    d='M17.817 9.76L12.15 6.488 1.217.175C.609-.175.005.037.005.769v25.72c0 .548.432.785.96.48l11.184-6.458 5.668-3.272 5.448-3.145c.64-.37.578-.876.039-1.166-.54-.29-5.487-3.168-5.487-3.168z'
                />
                <path
                    id='prefix__f'
                    d='M17.817 9.76L12.15 6.488 1.217.175C.609-.175.005.037.005.769v25.72c0 .548.432.785.96.48l11.184-6.458 5.668-3.272 5.448-3.145c.64-.37.578-.876.039-1.166-.54-.29-5.487-3.168-5.487-3.168z'
                />
                <path
                    id='prefix__i'
                    d='M17.817 9.76L12.15 6.488 1.217.175C.609-.175.005.037.005.769v25.72c0 .548.432.785.96.48l11.184-6.458 5.668-3.272 5.448-3.145c.64-.37.578-.876.039-1.166-.54-.29-5.487-3.168-5.487-3.168z'
                />
                <path
                    id='prefix__l'
                    d='M17.817 9.76L12.15 6.488 1.217.175C.609-.175.005.037.005.769v25.72c0 .548.432.785.96.48l11.184-6.458 5.668-3.272 5.448-3.145c.64-.37.578-.876.039-1.166-.54-.29-5.487-3.168-5.487-3.168z'
                />
                <filter
                    id='prefix__a'
                    width='106.7%'
                    height='125.5%'
                    x='-3.3%'
                    y='-9.1%'
                    filterUnits='objectBoundingBox'
                >
                    <feOffset dy='2' in='SourceAlpha' result='shadowOffsetOuter1' />
                    <feGaussianBlur in='shadowOffsetOuter1' result='shadowBlurOuter1' stdDeviation='2' />
                    <feColorMatrix in='shadowBlurOuter1' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0' />
                </filter>
                <rect id='prefix__b' width='210' height='55' x='0' y='0' rx='8' />
            </defs>
            <g fill='none' fillRule='evenodd' transform='translate(4 2)'>
                <use fill='#000' filter='url(#prefix__a)' xlinkHref='#prefix__b' />
                <use fill='#FFF' xlinkHref='#prefix__b' />
                <g transform='translate(19 14)'>
                    <mask id='prefix__e' fill='#fff'>
                        <use xlinkHref='#prefix__c' />
                    </mask>
                    <path
                        fill='url(#prefix__d)'
                        fillRule='nonzero'
                        d='M0.005 -0.423L0.005 27.422 14.046 13.5z'
                        mask='url(#prefix__e)'
                    />
                    <mask id='prefix__h' fill='#fff'>
                        <use xlinkHref='#prefix__f' />
                    </mask>
                    <path
                        fill='url(#prefix__g)'
                        fillRule='nonzero'
                        d='M17.817 9.76L12.149 6.488 0.005 -0.524 0.005 -0.423 14.046 13.5z'
                        mask='url(#prefix__h)'
                    />
                    <g>
                        <mask id='prefix__k' fill='#fff'>
                            <use xlinkHref='#prefix__i' />
                        </mask>
                        <path
                            fill='url(#prefix__j)'
                            fillRule='nonzero'
                            d='M0.005 27.422L0.005 27.524 12.149 20.511 17.817 17.239 14.046 13.5z'
                            mask='url(#prefix__k)'
                        />
                    </g>
                    <g>
                        <mask id='prefix__n' fill='#fff'>
                            <use xlinkHref='#prefix__l' />
                        </mask>
                        <path
                            fill='url(#prefix__m)'
                            fillRule='nonzero'
                            d='M17.817 9.76L14.046 13.5 17.817 17.239 24.295 13.5z'
                            mask='url(#prefix__n)'
                        />
                    </g>
                </g>
            </g>
        </Icon>
    );
};

export default AndroidDownloadIcon;
